import { Schema } from 'effect';

const Count = Schema.Int.check(Schema.isGreaterThanOrEqualTo(0));

// Shared participant-directory sync counters used by P1 and P4 sync response
// schemas. Both endpoints return the same five-counter shape from the
// participant-directory rebuild pipeline.
export const participantDirectorySyncCounterFields = {
  organisations: Count,
  authorisationServers: Count,
  apiResources: Count,
  apiEndpoints: Count,
  discoveryFailures: Count,
} as const;
